const SPINNER_FRAMES = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];
const SPINNER_INTERVAL = 100;

export function getSpinnerFrame() {
    const index = Math.floor(Date.now() / SPINNER_INTERVAL) % SPINNER_FRAMES.length;
    return SPINNER_FRAMES[index];
}
